import axios from 'axios'

//rename to geography

export default {
    async get() {
        try
        {            
            const response = await axios.get(`Timezones`)            
            return response
        }
        catch (error)
        {
            throw error
        }
    },

    //TODO move this to new geography controller
    async getCountries() {
        try
        {            
            const response = await axios.get(`Timezones/countries`)            
            return response
        }
        catch (error)
        {
            throw error
        }
    },
    // not used in SweldoNow
    // this can be reused when creating a separate attendance tracker project for multi-countries
    // async getServerDate() {
    //     try
    //     {            
    //         const response = await axios.get(`Timezones/serverdate`)            
    //         return response
    //     }
    //     catch (error)
    //     {
    //         throw error
    //     }
    // },

    //TODO move this to new geography controller
    async getProvinces() {
        try
        {            
            const response = await axios.get(`Timezones/provinces`)            
            return response
        }
        catch (error)
        {
            throw error
        }
    },

    //TODO move this to new geography controller
    async getCities() {
        try
        {            
            const response = await axios.get(`Timezones/cities`)            
            return response
        }
        catch (error)
        {
            throw error
        }
    },

    //TODO move this to new geography controller
    async getBaranggays() {
        try
        {            
            const response = await axios.get(`Timezones/baranggays`)            
            return response
        }
        catch (error)
        {
            throw error
        }
    },
}